var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"x-card-title-slot",attrs:{"shadow":"hover","header":""}},[_c(_setup.Merchants)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }